<ul *ngIf="sources?.length > 0" class="bulleted-list">
  <li *ngFor="let source of sources" class="p3-regular text-secondary gmt-16">
    <div>
      <p class="p3-regular text-secondary mb-0" [innerHTML]="source.title"></p>
      <ng-container *ngFor="let link of links(source.link) | keyvalue">
        <a
          *ngIf="link.value"
          [href]="link.value"
          class="d-inline-flex align-items-center p3-semibold text-primary text-decoration-none me-3"
          target="_blank"
          gptDataTrack="sources-list-link-open"
        >
          {{ 'LINK' | translate }}
          {{ source.link.includes('|') ? +link.key + 1 : null }}
          <i class="gpicon-external-link gpicon-md ms-2"></i>
        </a>
      </ng-container>
    </div>
  </li>
</ul>
